import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

import { ENVIRONMENT } from '../environment';

// Use the environment variables from ENVIRONMENT.firebase
const firebaseConfig = { ...ENVIRONMENT.firebase };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

window.dataLayer = window.dataLayer || [];

gtag('js', new Date());

gtag('config', firebaseConfig.measurementId, {
  cookie_flags: 'Secure;SameSite=Lax',
  cookie_domain: 'auto',
  cookie_update: true,
});
const enforceSecureCookies = () => {
  // List of all possible GA cookie variants
  const gaCookies = ['_ga', '_ga_YSMLVMT3WW'];

  gaCookies.forEach((name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) {
      const value = match[2];
      //  recreate with secure flags
      document.cookie = `${name}=${value}; Secure; SameSite=Lax; path=/; max-age=63072000; domain=.${window.location.hostname}`;
    }
  });
};

const setupCookies = () => {
  try {
    // First attempt (after 1s)
    enforceSecureCookies();

    // Second attempt (after 3s) in case GA was slow
    setTimeout(enforceSecureCookies, 3000);

    const interval = setInterval(enforceSecureCookies, 5000);
    setTimeout(() => clearInterval(interval), 20000);
  } catch (e) {
    console.error('Cookie enforcement failed:', e);
  }
};

// Initial setup
setTimeout(setupCookies, 1000);
export { analytics, firebaseConfig };
